import { createSelector } from 'reselect';
import constants from 'src/constants';
import splitDux from 'src/redux/split';
import appDux from 'src/redux/app';
import breakpointUtils from 'src/utils/breakpointUtils';

const { MODE_NAMES } = constants.app;

// The following are required for the composed selectors below
const isExtendedSidebarOpen = (state) =>
  state.designPro.ui.isExtendedSidebarOpen;

const shouldRenderSaveDesignButton = ({ designPro }) =>
  designPro.ui.isSidebarOpen &&
  !designPro.app.shareToken &&
  designPro.app.activeMode === MODE_NAMES.DESIGN &&
  !designPro.split.isSplitToolActive;
const shouldRenderControlBar = ({ designPro, machete }) =>
  machete.model.initialized &&
  !designPro.ui.isNativeApp &&
  !designPro.split.isSplitToolActive &&
  designPro.app.activeMode !== MODE_NAMES.SCREENSHOT &&
  !(breakpointUtils.isMobileDevice() && designPro.ui.isSidebarOpen);
const shouldRenderUndoRedoButtons = ({ designPro }) =>
  designPro.ui.isSidebarOpen && designPro.app.activeMode === MODE_NAMES.DESIGN;
const shouldRenderFooterLogoText = ({ designPro }) =>
  !(breakpointUtils.isMobileDevice() || designPro.ui.isSidebarOpen);
const shouldRenderFooter = ({ designPro }) =>
  !designPro.ui.isNativeApp &&
  designPro.app.activeMode !== MODE_NAMES.SCREENSHOT &&
  !(breakpointUtils.isMobileDevice() && designPro.ui.isSidebarOpen);

const isSidebarCloseButtonVisible = createSelector(
  isExtendedSidebarOpen,
  splitDux.selectors.isSplitToolActive,
  (isExtendedSidebar, isSplitTool) => !isExtendedSidebar && !isSplitTool,
);

const isScreenshotModeEnabled = createSelector(
  appDux.selectors.getDesignProFeatureAccesses,
  (featureAccesses) => {
    const feature = featureAccesses.find(
      ({ identifier }) => identifier === 'gallery_and_screenshot_mode',
    );
    const membershipGranted = feature?.enabled;
    return membershipGranted;
  },
);

const isRenderingsEnabled = createSelector(
  appDux.selectors.getOrgFeatureAccess,
  (featureAccesses) => {
    const feature = featureAccesses.find(
      ({ identifier }) => identifier === 'hi_def_rendering',
    );
    const membershipGranted = feature?.enabled;
    return membershipGranted;
  },
);

const canRequestRendering = createSelector(
  appDux.selectors.getJobDetails,
  (jobDetails) => jobDetails.can_request_hi_def_rendering,
);

export default {
  isScreenshotModeEnabled,
  isExtendedSidebarOpen,
  isSidebarCloseButtonVisible,
  shouldRenderControlBar,
  isRenderingsEnabled,
  canRequestRendering,
  shouldRenderFooter,
  shouldRenderFooterLogoText,
  shouldRenderSaveDesignButton,
  shouldRenderUndoRedoButtons,
};
